import { ERROR_MSG_DURATION, INFO_MSG_CODE, NO_ERROR_MSG_CODE } from '@/config';
import { toUpStr } from '../common';

/** 错误消息栈，防止同一错误同时出现 */
const errorMsgStack = new Map<string | number, string>([]);

function addErrorMsg(error: Service.RequestError) {
  errorMsgStack.set(error.code, error.msg);
}
function removeErrorMsg(error: Service.RequestError) {
  errorMsgStack.delete(error.code);
}
function hasErrorMsg(error: Service.RequestError) {
  return errorMsgStack.has(error.code);
}

/**
 * 显示错误信息
 * @param error
 */
export function showErrorMsg(error: Service.RequestError) {
  if (!error.msg || NO_ERROR_MSG_CODE.includes(error.code) || hasErrorMsg(error)) return;
  let type: 'error' | 'info' = 'error';
  if (!error.msg || INFO_MSG_CODE.includes(error.code) || hasErrorMsg(error)) {
    type = 'info';
  }
  addErrorMsg(error);
  window.console.warn(error.code, error.msg);
  window.$notification?.[type]({
    content: toUpStr(type),
    meta: error.msg,
    closable: false,
    keepAliveOnHover: true,
    duration: 3500
  });
  setTimeout(() => {
    removeErrorMsg(error);
  }, ERROR_MSG_DURATION);
}
